import React from 'react';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import BasicTable2 from '../tools/BasicTable2';
import * as ETVConstants from '../ETVConstants';

class OnPremisesServers extends React.Component {

    constructor(props) {
      super(props);
			this.resultListener = this.resultListener.bind(this);
    }

    state = {
      list:[],
      isLoaded:false,
    }

    componentDidUpdate() {
      if(!this.state.isLoaded) {
        this.loadServers();
      }
		}

    componentDidMount() {
      this.loadServers();
    }

    loadServers() {
			var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
			var url = ETVConstants.getServerBase()+"/on_premises_admin_service?user_id="+this.props.user_id+"&action=list";
      fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            console.log(JSON.stringify(result));
            this.setState({
              list: result.list,
              isLoaded:true
            });
          },
          (error) => {
            this.setState({
              list: [],
              isLoaded:true,
              error
            });
          }
        )
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(msg) {
      this.setState({window:'message_div',info_message:msg});
    }

    closeInfoMessage() {
      this.setState({info_message:undefined});
      this.showWindow('message_div',false);
    }

    restartTeamViewer(serverID) {
      	var url = ETVConstants.getServerBase()+"/todo";
        ETVConstants.sendCMDToServerListener(url,this.resultListener);
    }

    resultListener(val) {
			this.setState({isLoaded:false});
		}

    resultListener( res) {
      console.log("res="+JSON.stringify(res));
      this.showInfoMessage("success");
    }

    startTeamViewer( serverID) {
      	var url = ETVConstants.getServerBase()+"/on_premises_admin_service?server_id="+serverID+"&action=command&command="+encodeURIComponent("systemctl start teamviewerd");
        ETVConstants.sendCMDToServerListener(url,this.resultListener);
    }

    render() {

      const tableTitle = "";

      const serversData= [
          { title: ETVConstants.trans("last_connect"), field: 'last_connect', render: rowData => <Typography variant='body2'>{ETVConstants.getLastConnectInfo(rowData.last_connect)}</Typography> },
          { title: ETVConstants.trans("server_name"), field: 'server_name' },
          { title: ETVConstants.trans("public_ip"), field: 'public_ip' },
          { title: ETVConstants.trans("restart_teamviewer"), field: 'select_layout', render: rowData => <Button variant='contained' size='small' color='secondary' onClick={()=>this.startTeamViewer(rowData.server_id)}>TeamViewer</Button>},
      ];

      return (
        <div style={{width:800}}>
          <Card>
            <CardContent>
                <Typography variant="h5">{ETVConstants.trans("on_premise_servers")}</Typography>
                <Typography variant="body1" style={{marginTop:10}}>
                    {ETVConstants.trans("on_premise_servers_desc")}
                </Typography>
                <BasicTable2 style={{marginTop:20}} data={this.state.list} columns={serversData} title={tableTitle} pageSize={5} allow_search={true} />
            </CardContent>
          </Card>

          <Dialog
            open={this.state.window==='message_div'}
            maxWidth='xs'
            fullWidth={true}
            onClose={()=>{this.setState({window:''})}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{this.state.info_title}</DialogTitle>
            <DialogContent>
                <Typography variant='body1'>{this.state.info_message}</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{this.closeInfoMessage()}} color="primary">{ETVConstants.trans("close")}</Button>
            </DialogActions>
          </Dialog>

        </div>
      )
    }
}

export default OnPremisesServers;
